/**
 * @generated SignedSource<<8127ff3351d70a39a82fef261bc18252>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchSidebarList_ItemFragment$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchMoreActionsButtonFragment" | "BrainSearchTitleFragment">;
  readonly " $fragmentType": "BrainSearchSidebarList_ItemFragment";
};
export type BrainSearchSidebarList_ItemFragment$key = {
  readonly " $data"?: BrainSearchSidebarList_ItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchSidebarList_ItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchSidebarList_ItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BrainSearchTitleFragment"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BrainSearchMoreActionsButtonFragment"
    }
  ],
  "type": "BrainSearch",
  "abstractKey": null
};

(node as any).hash = "f8b9ce4359a1dd1efbbeb6cf67c1778e";

export default node;
